<template>
      <v-container class="app-page-container" v-if="user">
        <v-card class="shadow-none app-page-card">
          <v-card-title>
              <v-flex xs12>
                Messages
              </v-flex>
          </v-card-title>
          <v-card-text class="leaderboard" v-if="messageList">
            <MessageList v-bind:messageList='messageList'/>  
          </v-card-text>
        </v-card>
      </v-container>
</template>

<script>
import axios from '../../axios-auth'
import MessageList from './message_list.vue'

import {mapGetters} from 'vuex'

export default {
    data() {
      return {
        messageList: null,
        groupList: null,
        selected_groups: [],
        showGroups: -1,
        message_id: 0
      }
    },
    mounted () {
      this.initData()
   },
   computed: 
      mapGetters([
                      'user'
                  ])
   ,
   components : {
     MessageList
   },
   methods: {
    initData() {
      this.$store.commit('setBreadCrumbs',[{text: 'Messages', href: '/message_list'}])//#
      if (this.$route.params.id == null) this.message_id = 0
       else this.message_id = this.$route.params.id      
      this.getMessages()
    },
    getMessages() {
      this.feedback = null
      axios.get('/get-user-messages', this.$store.getters.getAxiosConfig)
        .then(res => {
            this.messageList = res.data.message_list
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    }
   }
  }
</script>

<style>

</style>